import { Icone } from '@domain/icone/icone'; // Supondo que você tenha um DTO para Icone
import { IconeDto } from '../dto/icone.dto';

export class IconeMapper {
  static toDTO(icon: Icone): IconeDto {
    return {
      cor: icon.cor,
      lib: icon.lib,
      nome: icon.nome,
      class: icon.class
    };
  }

  static toDomain(iconDto: IconeDto): Icone {
    return {
      cor: iconDto.cor,
      lib: iconDto.lib,
      nome: iconDto.nome,
      class: iconDto.class
    };
  }
}
